import $ from "jquery";
import { nextTick } from "vue";

export default {
  methods: {
    async set_active_tab(tab) {
      this.active_tab = tab;
      localStorage.setItem("active_tab", tab);
      await nextTick();

      if (tab === "Templates") {
        await this.get_assigned_templates();
      } else if (tab === "Job Forms") {
        this.get_forms();
      } else if (tab === "Job Descriptions") {
        this.selectedJobId = sessionStorage.getItem("selected_job_profile_id") || this.entity_type_id;
      } else if (tab === "Job Adverts") {
        await this.get_job_adverts();
      }
    },
    initialize_data_table() {
      this.$nextTick(() => {
        const table_ids = {
          Forms: "#manage-forms-table",
          Template: "#manage-template-table",
          "Invoice Steps": "#manage-invoice-table",
          Compliance: "#manage-compliance-table",
        };

        const tableId = table_ids[this.active_tab];
        const tableElement = document.querySelector(tableId);
        if (!tableElement) return;

        if ($.fn.DataTable.isDataTable(tableId)) {
          $(tableId).DataTable().destroy();
        }
        $(tableId).DataTable();
      });
    },
  },
};
